import React, { useContext } from "react";

// mui
import { styled } from "@material-ui/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

// component
import { FormattedMessage } from "react-intl";
import Typography from "@mui/material/Typography";
import TopTool from "./TopTool";
import BottomTool from "./BottomTool";
import { StoreContext } from "../../../../../../../../store/StoreProvider";

// image
import EmptyImg from "../../../../../../../../../images/ocr_image/ocrEmpty.png";

// utils
import { isEmpty } from "../../../../../../../../common/utils";
import { OCR_CONTENT } from "../../../Config";
import Act from "../../../../../../../../store/actions";

const ScrollableContainer = styled(Box)(({ theme }) => ({
  "&.MuiBox-root": {
    height: "100%",
    overflow: "auto",
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  border: "none",
  "& fieldset": { border: "none" },
  "& .MuiInputBase-root": {
    fontSize: "14px",
    position: "absolute",
    width: "100%",
    padding: "8px 12px",
  },
  "& .MuiInputBase-input": {
    textAlign: "justify",
  },
}));

const TextArea = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { digitalAI } = state;
  const { ocrImgList, pagination } = digitalAI;
  const { activePage } = pagination;

  const onChangeHandler = (e) => {
    if (isEmpty(ocrImgList) || isEmpty(ocrImgList[activePage])) {
      return;
    }

    ocrImgList[activePage][OCR_CONTENT] = e.target.value;

    dispatch({
      type: Act.DIGITAL_AI_SET_IMG_LIST,
      payload: ocrImgList,
    });
  };

  return (
    <Grid
      item
      xs
      sx={{
        marginLeft: "8px",
        backgroundColor: "#FFFFFF",
        padding: "16px 24px",
        borderRadius: "8px",
        boxShadow: "0 8px 16px 0 #096C9B1A",
      }}
    >
      {/* title and copy button */}
      <TopTool />
      {/*  OCR result field */}
      <Grid
        item
        xs
        sx={{
          height: "calc(100% - 108px)",
          border: "1px #CECECE solid",
          borderRadius: "8px",
          marginTop: "1rem",
          marginBottom: "1rem",
          padding: "0.5rem",
        }}
      >
        {!isEmpty(ocrImgList[activePage]?.ocrContent) ? (
          <ScrollableContainer>
            <StyledTextField
              fullWidth
              multiline
              value={ocrImgList[activePage][OCR_CONTENT]}
              onChange={onChangeHandler}
            />
          </ScrollableContainer>
        ) : (
          <Box
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <img src={EmptyImg} alt="empty data" width={200} height={200} />
            <Typography sx={{ fontSize: "14px", color: "#6D6D6D" }}>
              <FormattedMessage
                id="sna.sidetool.digitalAITool.ocr.textArea.notice"
                defaultMessage="匯入檔案後點擊產生OCR即可快速文字辨識"
              />
            </Typography>
          </Box>
        )}
      </Grid>
      {/*  download txt file and turn to AI page */}
      <BottomTool />
    </Grid>
  );
};

export default TextArea;
